import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { useI18n } from '#/i18n/hooks/useI18n';
import { userDashboardSavedItemsRoute } from '#/modules/userDashboard/routing/userDashboard.routes';
import { trackClicked } from '#/utils/analytics/track/trackClicked';
import {
  trackDismissToast,
  trackDisplayToast,
} from '#/utils/analytics/track/trackToast';
import { dismissToast, showToast } from '#/zustand-stores/toastsStore';

export function useOrgSavedToast() {
  const { i18n } = useI18n();
  const navigate = useNavigate();

  const showOrgSavedToast = useCallback(() => {
    trackDisplayToast({
      type: 'success_saved_org',
      current_page_url: window.location.href,
    });

    showToast({
      headline: i18n("You've saved this organization"),
      id: 'org-saved-toast',
      durationMs: 5000,
      dismissible: true,
      variant: 'success',
      actions: [
        {
          label: i18n('See all'),
          onClick: () => {
            trackClicked('Action Toast', {
              type: 'success_saved_org',
              current_page_url: window.location.href,
            });
            void navigate(userDashboardSavedItemsRoute.with({ tab: 'ORG' }));
            dismissToast('org-saved-toast');
          },
          type: 'button',
        },
      ],
      onDismiss: () => {
        trackDismissToast({
          type: 'success_saved_org',
          current_page_url: window.location.href,
        });
      },
    });
  }, [i18n, navigate]);

  return { showOrgSavedToast };
}
